<template>
    <v-container>
        <div v-if="changelog.length > 0">

            <v-row>
                <v-col class="col-12 col-md-4">
                    <div class=" group-header">Changelog</div>
                </v-col>
            </v-row>

            <div class="change-log">
                <div v-for="(release, idx) in changelog" :key="idx">
                    <div class="version-number">{{ release.version }}</div>
                    <p>Released: {{ release.date }}</p>
                    <div v-if="release.comment">
                        <ul>
                            <li v-for="comment in release.comment" :key="comment">{{ comment }}</li>
                        </ul>
                    </div>

                    <div v-if="release.added" class="group">
                        <h3>Added</h3>
                        <ul>
                            <li v-for="added in release.added" :key="added">{{ added }}</li>
                        </ul>
                    </div>
                    
                    <div v-if="release.changed" class="group">
                        <h3>Changed</h3>
                        <ul>
                            <li v-for="changed in release.changed" :key="changed">{{ changed }}</li>
                        </ul>
                    </div>

                    <div v-if="release.fixed" class="group">
                        <h3>Fixed</h3>
                        <ul>
                            <li v-for="fix in release.fixed" :key="fix">{{ fix }}</li>
                        </ul>
                    </div>

                </div>
            </div>

        </div>
    </v-container>
</template>

<script>
export default {
    props: {
        changelog: {
            type: Array,
            default: () => {
                return [{ }]
            }
        }
    },
    data: () => ({
    }),
}
</script>
<style scoped>
.change-log {
    margin-bottom: 32px;
}

.change-log>div {
    margin: 16px 0 32px;
}
.row {
    margin-bottom: 32px;
}
.version-number {
    font-size: 20px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid var(--text-color) !important;
    padding-left: 4px;
}
.group {
    margin: 32px 0;
}
.change-log ul > * {
    margin-left: 16px;
}


</style>